export default __webpack_public_path__ + "images/962de65a230a936b21ae294f16cec637-emoji-energetic.svg";